export default "__VITE_ASSET__CA_OgF1V__"